import { Colors } from '@revenuemarket/design';

import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export default function KeyboardArrowDown({
  width = 16,
  height = 16,
  fill = Colors.gray700,
  ...props
}: IconProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.33283 11.0081C9.24245 11.0081 9.15833 10.9937 9.08045 10.9648C9.00258 10.9359 8.92851 10.8864 8.85826 10.8163L5.48758 7.44563C5.38383 7.34175 5.3307 7.21119 5.3282 7.05394C5.32583 6.89681 5.37895 6.76388 5.48758 6.65513C5.59633 6.5465 5.72808 6.49219 5.88283 6.49219C6.03758 6.49219 6.16933 6.5465 6.27808 6.65513L9.33283 9.71006L12.3876 6.65513C12.4915 6.55138 12.622 6.49825 12.7793 6.49575C12.9364 6.49338 13.0693 6.5465 13.1781 6.65513C13.2867 6.76388 13.341 6.89563 13.341 7.05038C13.341 7.20513 13.2867 7.33688 13.1781 7.44563L9.80739 10.8163C9.73714 10.8864 9.66308 10.9359 9.5852 10.9648C9.50733 10.9937 9.4232 11.0081 9.33283 11.0081Z"
        fill={fill}
      />
    </Svg>
  );
}
